import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CalendarPlus, MapPin, Clock, ExternalLink, Ticket } from "lucide-react";
import { Link } from "react-router-dom";
import { assetUrl, fmtDate, timeRange, gcalLink, mapLink, canSignUp, fmtPrice } from "@/lib/events";

export function EventDialog({ event, onClose }) {
  return (
    <Dialog open={!!event} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-xl max-h-[88vh] overflow-y-auto" data-testid="event-dialog">
        {event && (
          <>
            {event.image_url && <img src={assetUrl(event.image_url)} alt={`${event.title} flyer`} className="w-full rounded-xl" />}
            <DialogHeader>
              <DialogTitle className="text-2xl text-[#550001]" data-testid="event-dialog-title">{event.title}</DialogTitle>
              <DialogDescription className="sr-only">Event details</DialogDescription>
            </DialogHeader>
            <ul className="space-y-1.5 text-sm text-[#1a1617]">
              <li className="flex gap-2"><Clock size={16} className="text-[#920e12] mt-0.5" aria-hidden="true" />{fmtDate(event.date)}{timeRange(event) && ` · ${timeRange(event)} ET`}</li>
              {(event.location_name || event.address) && (
                <li className="flex gap-2"><MapPin size={16} className="text-[#920e12] mt-0.5" aria-hidden="true" />
                  <a href={mapLink(event)} target="_blank" rel="noreferrer" className="underline hover:text-[#920e12]">{[event.location_name, event.address].filter(Boolean).join(", ")}</a>
                </li>
              )}
            </ul>
            {event.description && <p className="text-[#545454] whitespace-pre-line">{event.description}</p>}
            <div className="flex flex-wrap gap-2 pt-2">
              {canSignUp(event) && (
                <Button asChild className="bg-[#920e12] hover:bg-[#550001] text-white" data-testid="event-signup-btn">
                  <Link to={`/enroll/event/${event.id}`}><Ticket size={16} className="mr-1" /> Sign up · {fmtPrice(event.price_cents)}</Link>
                </Button>
              )}
              {event.register_url && (
                <Button asChild variant={canSignUp(event) ? "outline" : "default"} className={canSignUp(event) ? "border-[#920e12] text-[#920e12]" : "bg-[#920e12] hover:bg-[#550001] text-white"} data-testid="event-register-btn">
                  <a href={event.register_url} target="_blank" rel="noreferrer"><ExternalLink size={16} className="mr-1" /> Register</a>
                </Button>
              )}
              <Button asChild variant="outline" className="border-[#920e12] text-[#920e12]" data-testid="event-gcal-btn">
                <a href={gcalLink(event)} target="_blank" rel="noreferrer"><CalendarPlus size={16} className="mr-1" /> Add to Google Calendar</a>
              </Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
